import { ABTestClient, Experiments } from "../../../domain/repositories/ABTestClient";

declare global {
  interface Window {
    lkexp: Experiments | undefined;
  }
}

class GlobalThisABTestClient implements ABTestClient {
  private static instance: GlobalThisABTestClient;

  constructor() {}

  public static getInstance(): GlobalThisABTestClient {
    if (!GlobalThisABTestClient.instance) {
      GlobalThisABTestClient.instance = new GlobalThisABTestClient();
    }

    return GlobalThisABTestClient.instance;
  }

  public getExperiments(): Promise<Experiments | undefined> {
    try {
      const experiments = globalThis?.window?.lkexp;
      return Promise.resolve(experiments);
    } catch (_error) {
      return Promise.reject(undefined);
    }
  }
}

export { GlobalThisABTestClient };
